import React from 'react';
import { ImagePlaceholder } from './ImagePlaceholder';
const causas = [{
  title: 'El cortisol sube',
  desc: 'y le ordena al cuerpo acumular grasa en el abdomen'
}, {
  title: 'La insulina se desregula',
  desc: 'y cada carbohidrato se convierte en reserva'
}, {
  title: 'El estrógeno fluctúa',
  desc: 'generando hinchazón, retención y cambios de humor'
}, {
  title: 'La energía celular cae',
  desc: 'dejando el metabolismo en modo "supervivencia"'
}];
export function CausaReal() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-7">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-8">
        <div className="w-full md:w-1/2" data-id="element-9">
          <div className="aspect-[4/5] w-full rounded-2xl overflow-hidden" data-id="element-10">
            <img src="https://cdn.magicpatterns.com/uploads/9oXz3GCLBKaE9isxac51up/heylloyd-image-1781540319182.png" alt="Profesional de la nutrición sosteniendo ESBELTA®" className="w-full h-full object-cover" data-id="element-11" />
          </div>
        </div>

        <div className="w-full md:w-1/2" data-id="element-12">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-13">
            ¿Qué le pasa al cuerpo de la mujer después de los 35?
          </h2>

          <p className="text-lg text-gray-700 mb-6" data-id="element-14">
            El metabolismo femenino no se frena por comer más.{' '}
            <strong className="text-esbelta-violet" data-id="element-15">
              Se frena porque las hormonas pierden su equilibrio.
            </strong>
          </p>

          <p className="text-gray-600 mb-8" data-id="element-16">
            Con la edad, el estrés acumulado y los cambios hormonales propios de
            la perimenopausia y menopausia, ocurren 4 cosas al mismo tiempo:
          </p>

          <div className="space-y-4 mb-8" data-id="element-17">
            {causas.map((causa, idx) => <div key={idx} className="flex items-start gap-4 p-4 rounded-xl bg-gray-50 border border-gray-100" data-id="element-18">
                <div className="text-red-500 mt-1" data-id="element-19">🔴</div>
                <div data-id="element-20">
                  <span className="font-bold text-gray-900" data-id="element-21">{causa.title}</span>
                  <span className="text-gray-600" data-id="element-22"> → {causa.desc}</span>
                </div>
              </div>)}
          </div>

          <div className="bg-esbelta-lavender/30 p-6 rounded-xl border-l-4 border-esbelta-violet" data-id="element-23">
            <p className="text-gray-800 mb-4" data-id="element-24">
              <strong data-id="element-25">El resultado:</strong> Tu cuerpo no está roto. Está en
              modo defensa. Y ninguna dieta ni ejercicio puede revertir eso si
              no atacás la causa hormonal primero.
            </p>
            <p className="text-gray-800 font-medium" data-id="element-26">
              ESBELTA® fue formulada específicamente para atacar estas 4 causas
              al mismo tiempo, con una combinación de activos ancestrales que el
              cuerpo femenino maduro reconoce y utiliza.
            </p>
          </div>
        </div>
      </div>
    </section>;
}